import { render } from "./SurveyHeader.vue?vue&type=template&id=13e0e486&scoped=true&ts=true"
import script from "./SurveyHeader.vue?vue&type=script&lang=ts"
export * from "./SurveyHeader.vue?vue&type=script&lang=ts"

import "./SurveyHeader.vue?vue&type=style&index=0&id=13e0e486&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e0e486"]])

export default __exports__